/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================
*/

import { useEffect } from "react";
import { useLocation, Navigate } from "react-router-dom";
import PropTypes from "prop-types";
import { useAuth } from "pages/context/AuthContext";

import BarraAlertas from "pages/components/BarraAlertas";

import MDBox from "components/MDBox";
import { useMaterialUIController, setLayout } from "context";

import Footer from "examples/Footer";
//import WelcomeDialog from "pages/components/WelcomeDialog";

function DashboardLayout({ children }) {
  const [controller, dispatch] = useMaterialUIController();
  const {
    miniSidenav,
    uiOverrides,
    getGradientFromColor,
    getTextColorForBackground,
    sidenavColor,
  } = controller;

  const { pathname } = useLocation();

  useEffect(() => {
    setLayout(dispatch, "dashboard");
  }, [pathname, dispatch]);

  const { isAuthenticated, loading } = useAuth();

  // Evita render enquanto o estado de autenticação está a ser carregado
  if (loading) return null;

  // Se não estiver autenticado, redireciona para o login
  if (!isAuthenticated) {
    return <Navigate to="/auth/login" replace />;
  }

  return (
    <MDBox
      sx={(theme) => {
        const {
          breakpoints,
          transitions,
          functions: { pxToRem },
          palette,
        } = theme;

        const base = {
          p: 3,
          position: "relative",
          [breakpoints.up("xl")]: {
            marginLeft: miniSidenav ? pxToRem(120) : pxToRem(274),
            transition: transitions.create(["margin-left", "margin-right"], {
              easing: transitions.easing.easeInOut,
              duration: transitions.duration.standard,
            }),
          },
        };

        if (!uiOverrides?.appBg) return base;

        const styles = {
          ...base,
          background: getGradientFromColor(theme, uiOverrides.appBg),
        };

        styles.color =
          uiOverrides?.appText ??
          getTextColorForBackground(palette.gradients?.[sidenavColor]?.main || palette.white.main);

        return styles;
      }}
    >
      {/* Não mostrar o welcome em janelas/abas abertas a partir da app (ex.: PDF) */}
      {typeof window === "undefined" || !window.opener /*&& <WelcomeDialog /> */}

      <BarraAlertas />

      {children}

      {/* Footer global das páginas de dashboard */}
      <MDBox mt={3}>
        <Footer />
      </MDBox>
    </MDBox>
  );
}

DashboardLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default DashboardLayout;
